import { QueryClient } from '@tanstack/react-query'
import { isAuthExpiredError } from '@utils/isAuthExpiredError.js'

const BASE_QUERY_OPTIONS = {
  retry: false,
  networkMode: 'always'
}

const ASP_QUERY_OPTIONS = {
  ...BASE_QUERY_OPTIONS,
  throwOnError: isAuthExpiredError,
  gcTime: false
}

const QUERY_OPTIONS_BY_TARGET = {
  ASP: ASP_QUERY_OPTIONS,

  jb: ASP_QUERY_OPTIONS,

  MSTOCK: {
    ...BASE_QUERY_OPTIONS,
    throwOnError: isAuthExpiredError,
    gcTime: Infinity,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false
  },

  hana: {
    ...BASE_QUERY_OPTIONS,
    throwOnError: isAuthExpiredError,
    gcTime: 1000 * 60 * 10,
    refetchOnWindowFocus: false
  }
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: QUERY_OPTIONS_BY_TARGET[__APP_TARGET__] ?? QUERY_OPTIONS_BY_TARGET.ASP
  }
})
